import { useEffect, useState } from 'react';

import { GLOBAL } from 'saddlebag-browser';
import { v4 as uuid } from 'uuid';

import {
  buildImpressionEvent,
  buildInteractionEvent,
} from './utils/buildEvent';
import sendEvent from './utils/sendEvent';

import type { ComponentTrackingConfig } from './types';

const $window = GLOBAL.getWindow();

const useBehaviourTracking = <Wrapper extends HTMLElement>(
  config: ComponentTrackingConfig,
) => {
  const [elementRef, setElementRef] = useState<Wrapper | null>(null);
  useEffect(() => {
    if (!elementRef) return undefined;

    const impressionGuid = uuid();
    sendEvent(
      buildImpressionEvent($window.__internal.screenViewEventGuid, config),
      impressionGuid,
    );

    const onClick = () => {
      sendEvent(buildInteractionEvent(impressionGuid, config));
    };

    elementRef.addEventListener('click', onClick);
    return () => {
      elementRef.removeEventListener('click', onClick);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [elementRef]);

  return {
    ref: setElementRef,
  };
};

export default useBehaviourTracking;
